import React, { useEffect, useState, useContext } from "react";
import Logowhite from "../../assets/CreditAnalyse/img/logo-white.e7860257.png";
import Secureicon from "../../assets/CreditAnalyse/img/security-safe-svgrepo-com.svg";
import { useGetCreditAnalysisDataV2 } from "../../Hooks/useGetCreditAnalysisDataV2";
import { useHistory } from "react-router-dom";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import ReferenceContext from "../../Contexts/ReferenceContext";
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import { usePageLoad } from "../../Hooks/usePageLoad";
import { getPageName } from "../../Constants/PageNames";
import { queryString } from "../../Utility/QueryString";
import { useSkippedLeads } from "../../Hooks/useSkippedLeads";
import "../../assets/CreditAnalyse/css/loaderOTP.scss";
const CreditCheckV3 = () => {
    
    const urlParams = new URLSearchParams(window.location.search);
    const history = useHistory();
    const { visitorParameters } = useContext(VisitorParamsContext);
    const { getCreditAnalysisDataV2 } = useGetCreditAnalysisDataV2();
    const formData = JSON.parse(localStorage.getItem("formData")) || {};
    const { setReferenceID } = useContext(ReferenceContext);
    const { savePageLoad, calledOnce } = usePageLoad();
    let uuid = visitorParameters.visitor_parameters.uuid;
    const splitName = localStorage.getItem("split_name");
    const nextPage = urlParams.get("nextPage") || "";
    const { skippedLeads } = useSkippedLeads();

    useEffect(() => {
        (async () => {
            const uuid = visitorParameters.visitor_parameters.uuid ?? localStorage.getItem("uuid");
            const res = await getCreditAnalysisDataV2(
                uuid,
                formData,
                "send_otp"
            );
            setTimeout(() => {
                if (res.data.status === "Success" && res?.data?.response?.vendor_response?.Info?.Data?.reference) {
                    setReferenceID(res?.data?.response?.vendor_response?.Info?.Data?.reference);
                }

                if(res.data.status === "Success" && (res?.data?.response?.vendor_response?.Info?.Message === "Phone number assessed not to be high-risk" || res?.data?.response?.is_dupe === "yes")) {
                    let type = '';
                    if(res?.data?.response?.is_dupe === "yes") {
                        type = 'cc_duplicate';
                    } else {
                        type = 'phone_assessment';
                    }
 
                    const skippedLeadsResponse = skippedLeads(
                        type,
                        (uuid),
                        splitName
                    );


                    history.push(
                       "/credit_check_confirm?uuid=" +
                    visitorParameters.visitor_parameters.uuid + "&splitname=" + splitName + "&nextPage=" + nextPage
                    );
 
                } else {

                history.push(
                    "/credit_check_OTP?uuid=" +
                    visitorParameters.visitor_parameters.uuid + "&splitname=" + splitName + "&nextPage=" + nextPage
                );
            }
            }, 3000);
        })();
    }, []);

    useEffect(() => {
        if (!!uuid && !calledOnce) {
            const data = {
                uuid,
                page_name: getPageName("credit"),
                status: "visited",
                source: "regular",
            };
            (async () => {
                await savePageLoad(
                    visitorParameters.visitor_parameters,
                    data,
                    "visited_status",
                    splitName,
                    queryString,
                    visitorParameters.data
                );
            })();
        }
    }, [uuid, calledOnce]);

    return (
        <>
            <GetVisitorsParams />
            <div className="loaderOTP">
                <div className="bg_preldr">
                    <div className="container" style={{ marginTop: "-150px" }}>
                        <div>
                            <div className="brand">
                                <div className="logo pt-3 text-center">
                                    <a href="index.html">
                                        <img src={Logowhite} height={60} alt="" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="preloader">
                        <div className="box">
                            <div className="logo">
                                <img height={40} src={Secureicon} alt="" />
                            </div>
                        </div>
                        <div className="box" />
                        <div className="box" />
                        <div className="box" />
                        <div className="box" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreditCheckV3